import { MapPin } from "lucide-react";
import { TOWNS } from "./content";

export const Areas = () => (
  <section id="omraden" className="py-16 md:py-24" data-testid="areas-section">
    <div className="mx-auto max-w-6xl px-4 sm:px-6">
      <div className="grid gap-10 rounded-3xl border border-[var(--line)] bg-[var(--sand)] p-6 sm:p-10 lg:grid-cols-12 lg:items-center">
        <div className="lg:col-span-5">
          <p className="eyebrow">Serviceområden</p>
          <h2 className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl">Här arbetar vi</h2>
          <p className="mt-4 text-[var(--ink-soft)] md:text-lg">
            Med bas i Södertälje tar vi uppdrag i närområdet och på flera orter i Sörmland.
          </p>
        </div>
        <div className="lg:col-span-7">
          <div className="mb-5 flex items-center gap-3 rounded-2xl border border-[var(--line)] bg-white px-5 py-4 text-lg font-semibold" data-testid="area-södertälje">
            <MapPin size={20} className="shrink-0 text-[var(--red)]" aria-hidden="true" />
            <span>Södertälje</span>
            <span className="ml-auto rounded-full bg-[var(--sand)] px-3 py-1 text-xs font-semibold uppercase tracking-wider text-[var(--red)]">Vår bas</span>
          </div>
          <p className="mb-3 text-sm font-medium text-[var(--ink-soft)]">Vi hjälper även kunder i bland annat:</p>
          <ul className="grid grid-cols-1 gap-3 min-[400px]:grid-cols-2">
            {TOWNS.filter((town) => town !== "Södertälje").map((town) => (
              <li
                key={town}
                className="flex items-center gap-3 rounded-2xl bg-white px-5 py-4 text-lg font-semibold"
                data-testid={`area-${town.toLowerCase()}`}
              >
                <MapPin size={20} className="shrink-0 text-[var(--ink-soft)]" aria-hidden="true" />
                {town}
              </li>
            ))}
          </ul>
          <p className="mt-5 text-[var(--ink-soft)]" data-testid="areas-note">
            Behöver du hjälp någon annanstans? Hör av dig så ser vi om det går att lösa.
          </p>
        </div>
      </div>
    </div>
  </section>
);
